import React from "react";
import { Users, Rocket, Globe } from "lucide-react";

const benefits = [
    {
        icon: Users,
        title: "Rejoignez une",
        subtitle: "communauté engagée",
    },
    {
        icon: Rocket,
        title: "Accédez à des",
        subtitle: "opportunités uniques",
    },
    {
        icon: Globe,
        title: "Construisons",
        subtitle: "ensemble l'Afrique de demain",
    },
];

const AuthBenefits = () => {
    return (
        <div className="flex items-center justify-between">
            {benefits.map((item, index) => {
                const Icon = item.icon;
                return (
                    <React.Fragment key={index}>
                        <div className="flex items-center gap-2">
                            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary via-secondary to-primary flex items-center justify-center shadow-xl shadow-secondary/30 shrink-0">
                                <Icon size={30} className="text-white" strokeWidth={2.2} />
                            </div>
                            <div className="leading-snug">
                                <p className="text-xs font-medium text-white">{item.title}</p>
                                <p className="text-xs font-medium text-white">{item.subtitle}</p>
                            </div>
                        </div>
                        {index !== benefits.length - 1 && (
                            <div className="h-12 w-px bg-gradient-to-b from-transparent via-white/60 to-transparent mx-5 shrink-0" />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default AuthBenefits;